import type { ServiceType } from '@common/enums/serviceType';
import { getServiceLabel } from '@common/customControls/getServiceLabel';
import { ServiceCode } from '@common/enums/serviceCode';
import { getLanguage } from '@common/translate/translate';

export function getServiceNameForWorkList(serviceType: ServiceType, serviceCode?: ServiceCode) {
    const translate = getLanguage();

    if (serviceCode && serviceCode !== ServiceCode.PILOT && serviceCode !== ServiceCode.GGZOembl) {
        return getServiceLabel(serviceCode, 'workList');
    }

    if (serviceCode === ServiceCode.GGZOembl) {
        return `Embloom ${translate.serviceTypeEnum.examination.toLowerCase()}`;
    } else {
        return translate.serviceTypeEnum[serviceType];
    }
}
